import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { HeroHeadersBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { backgroundImage } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundImage";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { HeroBlock6 as Block } from "./HeroBlock6";
import { defaultData } from "./HeroBlock6DefaultData";
import { defaultStyles } from "./defaultStyles";
import imagePreview from "./hero_block_6_preview.png";

export const HeroBlock6: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "Hero Block 6",
    nameI18n:
      "settings.emails.visual_builder.block_type.hero_block.hero_block_6",
    version: 1,
    category: [HeroHeadersBlock],
    props: {
      imageContent: {
        name: "Image Content",
        nameI18n: "builder_ui.prop_type.image_content",
        prop: "children",
        accepts: ["Basic", "Media"],
        type: "children",
      },
      headerContent: {
        name: "Header Content",
        nameI18n: "builder_ui.prop_type.header_content",
        prop: "children",
        accepts: ["Basic", "Text"],
        type: "children",
      },
      primaryButton: {
        name: "Primary Button",
        nameI18n: "builder_ui.prop_type.primary_button",
        prop: "children",
        accepts: ["Basic", "Actions"],
        type: "children",
      },
      styles: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        prop: "styles",
        type: "styles",
        attributes: {
          backgroundColor: {
            ...backgroundColor,
            category: [DesignProp, GeneralProp],
            defaultValue: defaultStyles.backgroundColor,
            type: "color-without-alpha",
            nameI18n:
              "settings.emails.visual_builder.prop_type.styles.background_color",
          },
          backgroundImage: {
            ...backgroundImage,
            category: [DesignProp, GeneralProp],
          },
          padding: {
            ...padding,
            category: [DesignProp, PaddingsProp],
            defaultValue: defaultStyles.padding,
          },
          margin: {
            ...margin,
            category: [DesignProp, MarginsProp],
            defaultValue: defaultStyles.margin,
          },
        },
      },
    },
  },
};
